import React from "react";

function Controller() {
    return (
        <div>
            <h1>Football API Admin</h1>
        </div>
    );
}

export default Controller;
